require('./commonError.component.scss');

// @vendors
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
import { recordLinkV2, recordProcess } from 'utilities/tagging';

//@constants
import { EMPTY_STATE_NOCARD_BANKING } from 'constants/index';

// @components
import { EmptyState } from 'commonsComponents/emptyState';
import { OKButton } from 'commonsComponents/OKButton';
import { catalogue, analyticsId } from './analytics/commonError.tracking';

const RetryButton = ({ handleOnClick }) => (
  <OKButton modifier="secondary" onClick={handleOnClick}>
    <FormattedText value="preContractDocument-preContractDocument_retryButton" />
  </OKButton>
);

export const CommonError = ({ error, handleOnClick }) => {
  useEffect(() => {
    window.utag_last_name = '/migration/error/generalError';
    recordProcess(
      'proc-migracion',
      'paso_0',
      catalogue[analyticsId.ERROR_VIEW](
        error || formatText('preContractDocument-preContractDocument_errorMessage')
      ),
      true
    );
  }, []);

  const handleOnClickAndTracking = () => {
    recordLinkV2(catalogue[analyticsId.RETRY_BUTTON]());
    handleOnClick();
  };

  return (
    <div className="migration-common-error__wrapper">
      <EmptyState
        button={<RetryButton handleOnClick={handleOnClickAndTracking} />}
        primaryText={formatText('preContractDocument-preContractDocument_errorMessage')}
        iconType={EMPTY_STATE_NOCARD_BANKING}
        withMargin={true}
      />
      <div className="migration-common-error__content-err">
        <FormattedText value="preContractDocument-preContractDocument_pdfErrorMessage" />
      </div>
    </div>
  );
};

CommonError.propTypes = {
  handleOnClick: PropTypes.func.isRequired,
};
